export default "__VITE_ASSET__0ywz0yGz__"